import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { deviceTypes } from 'z-js-commons';
import { Menu, PropTypes as zrcPropTypes } from 'z-react-components';

export default class MenuWrapper extends Component {
    static propTypes = {
        device: PropTypes.oneOf([deviceTypes.PHONE, deviceTypes.TABLET, deviceTypes.DESKTOP]),
        footerLinks: zrcPropTypes.linkList,
        logoImgUrl: PropTypes.string,
        logoUrlLink: PropTypes.string,
        menuLinks: zrcPropTypes.linkList,
        show: PropTypes.bool,
        supportRequest: zrcPropTypes.supportRequest,
        version: PropTypes.string
    };

    static defaultProps = {
        enabledWidgets: [],
        show: false
    };

    render() {
        const { device, footerLinks, logoImgUrl, logoUrlLink, menuLinks, show, supportRequest, version } = this.props;

        return show ? (
            <Menu
                device={device}
                footerLinks={footerLinks}
                logoImgUrl={logoImgUrl}
                logoUrlLink={logoUrlLink}
                menuLinks={menuLinks}
                supportRequest={supportRequest}
                version={version}
            />
        ) : null;
    }
}
